<div class="dashboard-card">
  <div class="card-header">
    <h4 class="card-title">Expired Product Summary</h4>
  </div>
  <div class="card-content">
    <div *ngIf="isLoadingExpiredSummary" class="card-loading">
      <div class="loading-spinner"></div>
      <span>Loading expired summary data...</span>
    </div>
    <div *ngIf="!isLoadingExpiredSummary && expiredSummaryData.length === 0" class="empty-state-message">
      <i class="fa fa-tags empty-icon" aria-hidden="true"></i>
      <span>No expired product data available for the selected date range.</span>
    </div>
    <ul *ngIf="!isLoadingExpiredSummary && expiredSummaryData.length > 0" class="expired-list">
      <li class="expired-list-item" *ngFor="let item of expiredSummaryData">
        <div class="expired-list-store">{{ item.store_name }}</div>
        <div class="expired-list-count">
          <img class="expired-icon" src="assets/images/cabinet/expired.svg" alt="Expired icon">
          <span>{{ item.count }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
